import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0437 = React.lazy(() => import('./symbols/0437_tag_price_sale'));
const Symbol0438 = React.lazy(() => import('./symbols/0438_tag_price_sale_discount'));
const Symbol0439 = React.lazy(() => import('./symbols/0439_shopping_cart_basket_store'));
const Symbol0440 = React.lazy(() => import('./symbols/0440_shopping_cart_basket_store'));
const Symbol0441 = React.lazy(() => import('./symbols/0441_full_shopping_cart_basket_store'));
const Symbol0442 = React.lazy(() => import('./symbols/0442_shopping_cart_basket_store'));
const Symbol0443 = React.lazy(() => import('./symbols/0443_shopping_cart_basket_store'));
const Symbol0444 = React.lazy(() => import('./symbols/0444_price_discount_sale_coupon'));
const Symbol0445 = React.lazy(() => import('./symbols/0445_store_shop_shopping'));
const Symbol0446 = React.lazy(() => import('./symbols/0446_store_shop_shopping'));
const Symbol0447 = React.lazy(() => import('./symbols/0447_gift_wrapping'));
const Symbol0448 = React.lazy(() => import('./symbols/0448_shipping_box_delivery'));
const Symbol0449 = React.lazy(() => import('./symbols/0449_fragile_shipping_box_delivery'));
const Symbol0450 = React.lazy(() => import('./symbols/0450_shipping_box_delivery'));
const Symbol0451 = React.lazy(() => import('./symbols/0451_shipping_box_delivery'));
const Symbol0452 = React.lazy(() => import('./symbols/0452_archive_shipping_box_delivery'));
const Symbol0453 = React.lazy(() => import('./symbols/0453_shopping_bag_sale_store'));
const Symbol0454 = React.lazy(() => import('./symbols/0454_shopping_bag_sale_store'));
const Symbol0455 = React.lazy(() => import('./symbols/0455_delivery_van_shipping'));
const Symbol0456 = React.lazy(() => import('./symbols/0456_fragile_delivery_shipping'));
const Symbol0457 = React.lazy(() => import('./symbols/0457_store_shop_open'));
const Symbol0458 = React.lazy(() => import('./symbols/0458_store_shop_closed'));
const Symbol0459 = React.lazy(() => import('./symbols/0459_store_shop_open_nonstop'));
const Symbol0460 = React.lazy(() => import('./symbols/0460_new'));
const Symbol0461 = React.lazy(() => import('./symbols/0461_delivery_van_shipping_transport'));
const Symbol0462 = React.lazy(() => import('./symbols/0462_fast_delivery_van_shipping_transport'));
const Symbol0463 = React.lazy(() => import('./symbols/0463_fast_delivery_van_shipping_transport'));
const Symbol0464 = React.lazy(() => import('./symbols/0464_shipping_box_delivery'));
const Symbol0465 = React.lazy(() => import('./symbols/0465_shopping_cart_basket_store'));
const Symbol0466 = React.lazy(() => import('./symbols/0466_shopping_cart_basket_store_successful'));

export interface IProps {}

const Shopping: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0437_tag_price_sale" symbol={<Symbol0437 />} />
      <LazySymbol id="0438_tag_price_sale_discount" symbol={<Symbol0438 />} />
      <LazySymbol id="0439_shopping_cart_basket_store" symbol={<Symbol0439 />} />
      <LazySymbol id="0440_shopping_cart_basket_store" symbol={<Symbol0440 />} />
      <LazySymbol id="0441_full_shopping_cart_basket_store" symbol={<Symbol0441 />} />
      <LazySymbol id="0442_shopping_cart_basket_store" symbol={<Symbol0442 />} />
      <LazySymbol id="0443_shopping_cart_basket_store" symbol={<Symbol0443 />} />
      <LazySymbol id="0444_price_discount_sale_coupon" symbol={<Symbol0444 />} />
      <LazySymbol id="0445_store_shop_shopping" symbol={<Symbol0445 />} />
      <LazySymbol id="0446_store_shop_shopping" symbol={<Symbol0446 />} />
      <LazySymbol id="0447_gift_wrapping" symbol={<Symbol0447 />} />
      <LazySymbol id="0448_shipping_box_delivery" symbol={<Symbol0448 />} />
      <LazySymbol id="0449_fragile_shipping_box_delivery" symbol={<Symbol0449 />} />
      <LazySymbol id="0450_shipping_box_delivery" symbol={<Symbol0450 />} />
      <LazySymbol id="0451_shipping_box_delivery" symbol={<Symbol0451 />} />
      <LazySymbol id="0452_archive_shipping_box_delivery" symbol={<Symbol0452 />} />
      <LazySymbol id="0453_shopping_bag_sale_store" symbol={<Symbol0453 />} />
      <LazySymbol id="0454_shopping_bag_sale_store" symbol={<Symbol0454 />} />
      <LazySymbol id="0455_delivery_van_shipping" symbol={<Symbol0455 />} />
      <LazySymbol id="0456_fragile_delivery_shipping" symbol={<Symbol0456 />} />
      <LazySymbol id="0457_store_shop_open" symbol={<Symbol0457 />} />
      <LazySymbol id="0458_store_shop_closed" symbol={<Symbol0458 />} />
      <LazySymbol id="0459_store_shop_open_nonstop" symbol={<Symbol0459 />} />
      <LazySymbol id="0460_new" symbol={<Symbol0460 />} />
      <LazySymbol id="0461_delivery_van_shipping_transport" symbol={<Symbol0461 />} />
      <LazySymbol id="0462_fast_delivery_van_shipping_transport" symbol={<Symbol0462 />} />
      <LazySymbol id="0463_fast_delivery_van_shipping_transport" symbol={<Symbol0463 />} />
      <LazySymbol id="0464_shipping_box_delivery" symbol={<Symbol0464 />} />
      <LazySymbol id="0465_shopping_cart_basket_store" symbol={<Symbol0465 />} />
      <LazySymbol id="0466_shopping_cart_basket_store_successful" symbol={<Symbol0466 />} />
    </>
  );
});

Shopping.displayName = 'Shopping';

export default Shopping;
